import { getPrimaryTracker } from 'usage-tracker-container';
import { CardSection } from 'foundations-components/transitional/components/Card';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { View } from 'foundations-components/components/View';
import { FeatureTable } from 'feature-monetization';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureTableStyledWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(CardWrapper, {
    borderRadius: "300",
    blockSize: "100%",
    marginBlock: "0",
    children: /*#__PURE__*/_jsx(CardSection, {
      padding: "0",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(View, {
        padding: "1000",
        children: children
      })
    })
  });
};
export const FeatureTableContainer = ({
  skuCategoryName,
  productApiNames,
  screen
}) => {
  return /*#__PURE__*/_jsx(FeatureTable, {
    skuCategoryName: skuCategoryName,
    productApiNames: productApiNames,
    usageTracker: getPrimaryTracker(),
    screen: screen,
    StyledWrapper: FeatureTableStyledWrapper
  });
};